import makeApiRequest from 'src/lib/makeApiRequest';
import { API_URL } from 'src/constants/Endpoints';
import { SubscriptionPayload } from 'src/models/SubscriptionModel';

export const postSubscriptionData =
(organisation: string, payload: SubscriptionPayload) => makeApiRequest({
  method: 'POST',
  url: `${API_URL.subscription}`,
  organisation,
  data: payload,
});

export const putSubscriptionData =
  (id: number, organisation: string, payload: SubscriptionPayload) => makeApiRequest({
    method: 'PUT',
    url: `${API_URL.subscription}/${id}`,
    organisation,
    data: payload,
  });

export const getSubscriptionData =
  (id: number, organisation: string) => makeApiRequest({
    method: 'GET',
    url: `${API_URL.subscription}/${id}`,
    organisation,
  });

export const deleteSubscriptionData =
  (id: number, organisation: string) => makeApiRequest({
    method: 'DELETE',
    url: `${API_URL.subscription}/${id}`,
    organisation,
  });
